export default function isBetweenInclusive(target: number, lo: number, hi: number): boolean {
    return target >= lo && target <= hi;
}
